import { render, staticRenderFns } from "./SLink2.vue?vue&type=template&id=3e6e72b8&scoped=true"
import script from "./SLink2.vue?vue&type=script&lang=js"
export * from "./SLink2.vue?vue&type=script&lang=js"
import style0 from "./SLink2.vue?vue&type=style&index=0&id=3e6e72b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6e72b8",
  null
  
)

export default component.exports